import { Field, useField } from 'formik'

import { ErrorMessage } from '@components/ErrorMessage'
import { theme } from '@theme'

export function TextArea({
  name,
  placeholder = 'Additional Info…',
  rows = '10',
  column = '10',
  errorMsgVariant = 'errorGrayBG',
  ...otherProps
}) {
  const [, { error, touched }] = useField(name)
  return (
    <>
      <Field
        as="textarea"
        rows={rows}
        column={column}
        name={name}
        placeholder={placeholder}
        {...otherProps}
      />
      {error && touched && (
        <ErrorMessage
          color={theme.newColors[errorMsgVariant]}
          errorText={error}
        >
          {error}
        </ErrorMessage>
      )}
    </>
  )
}
